const mobileButtonAppearTransitionDurationMs = 150;
const header = "_61h1fz5ria";
const center = "_61c159ggr";
const image = "_61iub1fu1";
const heading = "_61htpsu6f";
const subHeading = "_61s1hc0ks4";
const buttonWrapper = "_61bmr4h82";
const mobileButtonWrapper = "_61m1oz851f";

export { buttonWrapper, center, header, heading, image, mobileButtonAppearTransitionDurationMs, mobileButtonWrapper, subHeading };
import "./sticky-header.style.linaria.module.css";
//# sourceMappingURL=sticky-header.style.js.map
